import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import * as nl from "./i18n/nl.json";
import * as en from "./i18n/en.json";

const resources = {
  nl: {
    translation: nl,
  },
  en: {
    translation: en,
  },
};

export const languageDutch = "nl";
export const languageEnglish = "en";
export const routePrefixLanguages = [languageEnglish]; // Only the languages with a prefix, equal to all languages except Dutch

void i18n.use(initReactI18next).init({
  fallbackLng: languageDutch,
  supportedLngs: [languageDutch, languageEnglish],
  resources,
  interpolation: {
    escapeValue: false,
  },
});
